import React from 'react'

import { useInView } from 'react-cool-inview'

import { string, bool } from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'

import TrustedBrands from './TrustedBrands'

function TrustedBrandsSection({ locale, extractingCoreStyles = false }) {
  const { observe, inView } = useInView({
    rootMargin: '200px',
    unobserveOnEnter: true,
  })

  const title = i18n.t('valueProposition.brands.title', {
    ns: 'new-home',
    lng: locale,
  })

  const renderTrustedBrandsContent = () => (
    <div className="trusted-brands-section__container">
      <h2 className="trusted-brands-section__title">
        {title}
      </h2>
      <TrustedBrands />
    </div>
  )

  return (
    <section className="trusted-brands-section" ref={observe}>
      {(inView || extractingCoreStyles) && renderTrustedBrandsContent()}
      <noscript>
        {renderTrustedBrandsContent()}
      </noscript>
    </section>
  )
}

TrustedBrandsSection.propTypes = {
  locale: string.isRequired,
  extractingCoreStyles: bool,
}

export default TrustedBrandsSection
